// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flesh-container {
  /* background-color: #ffeb93; */
  overflow: hidden;
  width: 100%;
  border-radius: 10px;
  position: relative;
}

.flesh {
  display: flex;
  align-items: center;
  white-space: nowrap;
  width: 200%; /* Full width to accommodate both marquees */
  animation: marquee 30s linear infinite;
}

.marquee {
  display: flex;
  width: 100%; /* Width for each marquee container */
}

.marquee-item {
  display: inline-block;
  padding: 10px 20px;
  margin-right: 30px; /* Space between blocks */
  /* background-color: #fff;
  border: 1px solid #ccc; */
  border-radius: 8px;
  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */
}

.flesh:hover {
  animation-play-state: paused; /* Pause scrolling on hover */
}

.news-link {
  color: #007bff;
  text-decoration: underline;
}

.news-link:hover {
  text-decoration: none;
}

@keyframes marquee {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

/* Media query for screens up to 768px */
@media screen and (max-width: 768px) {
  .marquee-item {
    margin-right: 15px; /* Reduce spacing for mobile */
  }
}

/* Media query for screens up to 480px */
@media screen and (max-width: 480px) {
  .flesh {
    font-size: 14px; /* Smaller font size for mobile */
  }

  .marquee-item {
    margin-right: 10px; /* Further reduce spacing for smaller screens */
  }
}
`, "",{"version":3,"sources":["webpack://./src/FrontEnd/NewsUpdate/NewsUpdate.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW,EAAE,4CAA4C;EACzD,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,WAAW,EAAE,qCAAqC;AACpD;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB,EAAE,yBAAyB;EAC7C;2BACyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,4BAA4B,EAAE,6BAA6B;AAC7D;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,kBAAkB,EAAE,8BAA8B;EACpD;AACF;;AAEA,wCAAwC;AACxC;EACE;IACE,eAAe,EAAE,iCAAiC;EACpD;;EAEA;IACE,kBAAkB,EAAE,+CAA+C;EACrE;AACF","sourcesContent":[".flesh-container {\n  /* background-color: #ffeb93; */\n  overflow: hidden;\n  width: 100%;\n  border-radius: 10px;\n  position: relative;\n}\n\n.flesh {\n  display: flex;\n  align-items: center;\n  white-space: nowrap;\n  width: 200%; /* Full width to accommodate both marquees */\n  animation: marquee 30s linear infinite;\n}\n\n.marquee {\n  display: flex;\n  width: 100%; /* Width for each marquee container */\n}\n\n.marquee-item {\n  display: inline-block;\n  padding: 10px 20px;\n  margin-right: 30px; /* Space between blocks */\n  /* background-color: #fff;\n  border: 1px solid #ccc; */\n  border-radius: 8px;\n  /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); */\n}\n\n.flesh:hover {\n  animation-play-state: paused; /* Pause scrolling on hover */\n}\n\n.news-link {\n  color: #007bff;\n  text-decoration: underline;\n}\n\n.news-link:hover {\n  text-decoration: none;\n}\n\n@keyframes marquee {\n  0% {\n    transform: translateX(0);\n  }\n\n  100% {\n    transform: translateX(-50%);\n  }\n}\n\n/* Media query for screens up to 768px */\n@media screen and (max-width: 768px) {\n  .marquee-item {\n    margin-right: 15px; /* Reduce spacing for mobile */\n  }\n}\n\n/* Media query for screens up to 480px */\n@media screen and (max-width: 480px) {\n  .flesh {\n    font-size: 14px; /* Smaller font size for mobile */\n  }\n\n  .marquee-item {\n    margin-right: 10px; /* Further reduce spacing for smaller screens */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
